import { ApiFieldError } from 'src/types';
import actionCreatorFactory from 'typescript-fsa';

export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/DEPOSITACCOUNTSLOANAPPSADVISOR`
);
type APIError = ApiFieldError;
export const allDepositAccountsLoanAppsRequest = actionCreator('request');

export const allDepositAccountsLoanAppsRequestSuccess = actionCreator<any>('success');

export const allDepositAccountsLoanAppsRequestFail =
  actionCreator<APIError[]>('fail');

export const updateDepositAccountsLoanApps = actionCreator<any>('update');
export const _updateDepositAccountsAdvisorLoanAppsInStore = actionCreator<any>(
  'update-deposit-accounts-store'
);

export const updateMultipleDepositAccountsLoanApps = actionCreator<any>(
  'update-multiple-deposit-accounts-loanApps'
);
